
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(3866|4274|4913|7335|7778)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
